<template>
    <div class="case-study-full-image">
        <picture>
            <source media="(max-width: 767px)" :data-srcset="image.mobileImage[0].url"/>
            <source media="(min-width: 768px)" :data-srcset="image.desktopImage[0].url"/>
            <img
                    v-if="image && image.desktopImage && image.mobileImage"
                    :data-src="image.desktopImage[0].url"
                    class="lazyload block w-full"
            />
        </picture>
    </div>
</template>

<script>
    export default {
        name : 'case-study-full-image',

        props : {
            block : {
                type : Object,
                default : () => {}
            }
        },

        computed : {
            image(){
                return this.block.caseStudyImagesFullWidth[0];
            }
        },

        mounted(){
        }
    }
</script>